export enum EstadosMensajesAPIEnum {
    Enviado = 'Enviado',
    Pendiente = 'Pendiente',
    Error = 'Error'
}
